export function searchTermEvent(search: string) {
  // Prevent sending Google event when user clears input
  if (search.length > 0) {
    return {
      event: 'search',
      search_term: search,
    };
  }
}